import { render } from "./PlaceList.vue?vue&type=template&id=4dfcc6b0&scoped=true&ts=true"
import script from "./PlaceList.vue?vue&type=script&lang=ts"
export * from "./PlaceList.vue?vue&type=script&lang=ts"

import "./PlaceList.vue?vue&type=style&index=0&id=4dfcc6b0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1361425700/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfcc6b0"]])

export default __exports__